import { useState } from 'react';

// graphql
import { CashTransferStatus, PageInfo, useCpt_PlayerBalanceAdditionsQuery } from '@/generated/graphql';

// interfaces
import {
  IPlayerAdditionTransactionTable,
  IPlayerBalanceAddition,
  IPlayerBalanceAdditionQueryVariable,
  mapGQLPlayerBalanceAddition,
} from '@/shared/interfaces';

// helpers
import { formatNumber } from '@/shared/constants';

// components
import { TablePlayerBalanceAdditions } from './table';

export const PlayerAdditions = () => {
  const [additions, setAdditions] = useState<IPlayerAdditionTransactionTable[]>([]);

  const [queryVariable, setQueryVariable] = useState<IPlayerBalanceAdditionQueryVariable>({
    first: 25,
    filterBy: {
      status: [CashTransferStatus.VirifiedByAuditor, CashTransferStatus.VirifiedByCashier, CashTransferStatus.Confirmed],
    },
  });
  const [additionPageInfo, setAdditionPageInfo] = useState<PageInfo>();
  const [additionTotalCount, setAdditionTotalCount] = useState<number>(0);

  const playerBalanceAdditionQuery = useCpt_PlayerBalanceAdditionsQuery({
    notifyOnNetworkStatusChange: true,
    variables: queryVariable,
    onCompleted(data) {
      const mapPlayerBalanceAdditions: IPlayerBalanceAddition[] = data.playerBalanceAdditions.nodes.map((playerBalanceAddition) =>
        mapGQLPlayerBalanceAddition(playerBalanceAddition),
      );

      setTimeout(() => {
        setAdditions(
          mapPlayerBalanceAdditions.map((x) => ({
            id: x.id,
            amountDisplay: formatNumber(x.amount),
            referenceId: x.referenceId,
            transactionType: x.transactionType,
            createdAt: x.createdAt,
            status: x.status,

            playerName: `${x.player.firstName} ${x.player.lastName}`,
            cashierName: `${x.cashier.firstName} ${x.cashier.lastName}`,
            auditorName: `${x.auditor.firstName} ${x.auditor.lastName}`,
            cashierId: x.cashier.id,
            paymentGatewayNumber: `${x.paymentGateway.accountNumber} (${x.paymentGateway.name})`,
            notes: x.notes,
          })),
        );
        setAdditionPageInfo(data.playerBalanceAdditions.pageInfo);
        setAdditionTotalCount(data.playerBalanceAdditions.totalCount);
      }, 100);
    },
  });

  return (
    <>
      <TablePlayerBalanceAdditions
        rows={additions}
        setPlayerBalanceAdditionQueryVariable={setQueryVariable}
        playerBalanceAdditionQueryVariable={queryVariable}
        totalCount={additionTotalCount}
        pageInfo={additionPageInfo}
        getPlayerBalanceAdditionLoading={playerBalanceAdditionQuery.loading}
      />
    </>
  );
};
